import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import type { ToastType } from './toast.service';

export interface BatchListState {
  pageIndex: number;
  pageSize: number;
  searchText: string;
  statusFilter: string;
  /** Applied Document Type filter (PFEU only) */
  documentTypeFilter?: string;
  /** Applied Uploaded by filter (PFEU/VCF only) */
  uploadedByFilter?: string;
  createdFromDate: string;
  createdToDate: string;
  sortField?: string;
  sortOrder?: 'asc' | 'desc' | null;
  selectedBatch?: string; // batchId of the selected/highlighted batch
  checkedBatches?: string[]; // batchIds of checked/selected batches
  deferredToast?: { type: ToastType; title?: string; message: string; duration?: number };
}

@Injectable({
  providedIn: 'root'
})
export class BatchStateService {
  private defaultState: BatchListState = {
    pageIndex: 0,
    pageSize: 10,
    searchText: '',
    statusFilter: '',
    documentTypeFilter: '',
    uploadedByFilter: '',
    createdFromDate: '',
    createdToDate: '',
    sortField: undefined,
    sortOrder: null,
    selectedBatch: undefined,
    checkedBatches: [],
    deferredToast: undefined
  };

  private stateSubject = new BehaviorSubject<BatchListState>(this.defaultState);
  public state$ = this.stateSubject.asObservable();

  constructor() {}

  public saveState(state: BatchListState): void {
    this.stateSubject.next({ ...state });
  }

  public getState(): BatchListState {
    return this.stateSubject.value;
  }

  public clearState(): void {
    this.stateSubject.next({ ...this.defaultState });
  }

  public updateSelectedBatch(batchId: string): void {
    const currentState = this.getState();
    this.saveState({
      ...currentState,
      selectedBatch: batchId
    });
  }
}